import React, { useState, useEffect } from 'react';
import { useStyles } from './styles';
import CloseIcon from '@material-ui/icons/Close';
import AppHelper from 'helpers/AppHelper';
import { IconSelfPaced, IconWithSchedule } from 'assets/images';
import { Button } from "@material-ui/core";
import { arrowRight } from "assets/icons/importIcon";

interface ChooseBrikScheduleProps {
    item?: any,
    isEdit?: boolean,
    type?: number,
    typeLength?: number,
    nextStep: (e: any, type: any) => void,
    backStep: (e: any, type: any) => void,
    handleCloseModal?: () => void,
    setTypeLength: (type: number) => void
}

export const ChooseBrikSchedule = (props: ChooseBrikScheduleProps) => {
    const classes = useStyles();
    const [select, setSelect] = useState(-1)

    useEffect(() => {
        if (props?.typeLength) {
            setSelect(props?.typeLength)
        }
    }, [props?.typeLength])

    const onHandleCloseModal = () => {
        if (props?.handleCloseModal) {
            props?.handleCloseModal();
        } else {
            AppHelper.hideGlobalModal();
        }
    };

    return (
        <div className={classes.bodyModalList}>
            <div className={classes.iconCloseIcon} onClick={onHandleCloseModal}>
                <CloseIcon />
            </div>

            <div className={classes.contentTitle} data-cy="cypress-course-learning-time-modal-header">How will they learn?</div>

            <div className={classes.listType}>
                <div
                    className={`${classes.itemType} ${select === 0 ? classes.selected : ""}`}
                    onClick={() => {
                        setSelect(0);
                        props?.setTypeLength(0);
                    }}
                >
                    <img src={IconSelfPaced} className={classes.icon} alt='' />
                    <p className={classes.typeTitle} data-cy="cypress-course-learning-self-paced">Self-paced</p>
                    <p className={classes.typeDes}>
                        Learn one chapter or lesson at a time and at their own pace.
                    </p>
                </div>

                <div
                    className={`${classes.itemType2}  ${select === 2 ? classes.selected : ""}`}
                    onClick={() => {
                        setSelect(2);
                        props?.setTypeLength(2);
                    }}
                >
                    <img src={IconWithSchedule} className={classes.icon} alt='' />
                    <p className={classes.typeTitle} data-cy="cypress-course-learning-with-a-schedule">With a schedule</p>
                    <p className={classes.typeDes} style={{ marginBottom: 30 }}>
                        Schedule specific chapters or lessons weekly or daily.
                    </p>
                </div>
            </div>

            <div className={classes.footerModal}>
                <div className={classes.buttonBack}>
                    <Button variant="contained" onClick={(e: any) => props?.backStep(e, props?.type)} data-cy="cypress-course-learning-time-back-button">
                        Back
                    </Button>
                </div>

                <div className={classes.nextBtn}>
                    <Button variant="contained" onClick={(e: any) => props?.nextStep(e, props?.type)} disabled={select === -1} data-cy="cypress-course-learning-time-next-button">
                        <span>Next</span>
                        <img src={arrowRight} alt="" />
                    </Button>
                </div>

            </div>
        </div>
    );
}